import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { SocialNetwork } from '@repo/types';
import API from '../endpoints';

// 30 minutes frontend cache for social network list query
const CACHE_TIME = 30 * 60 * 1000;

export const useSocialNetworksQuery = () => {
  return useQuery({ queryKey: ['socialNetworks'], queryFn: fetchSocialNetworks, staleTime: CACHE_TIME });
};

const fetchSocialNetworks: QueryFunction<SocialNetwork[], [string]> = async () => {
  const { data } = await axios.get<SocialNetwork[]>(API.endpoints.socialNetworks);
  return data;
};
